import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const WeightLossPage = lazy(() => import('../pages/weight-loss/page'));
const RatesPage = lazy(() => import('../pages/rates/page'));
const PatientPortalPage = lazy(() => import('../pages/patient-portal/page'));
const QMAPPage = lazy(() => import('../pages/qmap/page'));
const EmploymentPage = lazy(() => import('../pages/employment/page'));
const AppointmentPage = lazy(() => import('../pages/appointment/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const PaymentSetupPage = lazy(() => import('../pages/payment-setup/page'));
const UnderstandingAnxietyDisorders = lazy(() => import('../pages/blog/posts/understanding-anxiety-disorders'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/rates',
    element: <RatesPage />,
  },
  {
    path: '/patient-portal',
    element: <PatientPortalPage />,
  },
  {
    path: '/appointment',
    element: <AppointmentPage />,
  },
  {
    path: '/qmap',
    element: <QMAPPage />,
  },
  {
    path: '/weight-loss',
    element: <WeightLossPage />,
  },
  {
    path: '/employment',
    element: <EmploymentPage />,
  },
  {
    path: '/blog',
    element: <BlogPage />,
  },
  {
    path: '/blog/understanding-anxiety-disorders',
    element: <UnderstandingAnxietyDisorders />,
  },
  {
    path: '/payment-setup',
    element: <PaymentSetupPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;